import translationService from '../../services/ClassenService/modules/translationService';

const state = {
  translations: [],
  keysWithTranslations: [],
  languageId: 1
};

const mutations = {
  SET_TRANSLATIONS: (state, translations) => {
    state.translations = translations;
  },

  SET_KEYS_WITH_TRANSLATIONS: (state, translations) => {
    state.keysWithTranslations = translations;
  },

  SET_LANGUAGE: (state, languageId) => {
    state.languageId = languageId;
  }
};

const getters = {
  getTranslations() {
    return state.translations;
  },

  getAllKeysWithTranslations() {
    return state.keysWithTranslations;
  },

  getLanguage() {
    return state.languageId;
  }
};

const actions = {
  getTranslations: (context) => {
    if (context.state.translations.length === 0) {
      translationService.getTranslations().then((respone) => {
        context.commit('SET_TRANSLATIONS', respone.data)
      });
    }
  },

  forceReloadTranslations: (context) => {
    translationService.getAllKeysWithTranslations().then((response) => {
      context.commit('SET_KEYS_WITH_TRANSLATIONS', response);
    });
  },

  getAllKeysWithTranslations: (context) => {
    if (context.state.keysWithTranslations.length === 0) {
      translationService.getAllKeysWithTranslations().then((response) => {
        context.commit('SET_KEYS_WITH_TRANSLATIONS', response);
      });
    }
  },

  getTranslation: ({commit}, translationId) => new Promise((resolve, reject) => {
    translationService.getTranslation(translationId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updateTranslation: ({commit}, {
    translationId,
    translationData
  }) => new Promise((resolve, reject) => {
    translationService.updateTranslation(translationId, translationData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteTranslation: ({commit}, translationId) => new Promise((resolve, reject) => {
    translationService.deleteTranslation(translationId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addTranslation: ({commit}, translationData) => new Promise((resolve, reject) => {
    translationService.addTranslation(translationData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

};

export default {
  state, mutations, getters, actions,
};
